import { SVSummaryCardItem } from '@/types/common';
import { SVSummaryCard } from '../core';
import { TransactionReviewTransactionDetails } from '@/types/transactionReview';
import TransactionReviewAmount from './TransactionReviewAmount';
import { getTransactionReviewDeliverySpeed } from '@/utils/transactionReview';
import { formatDateTimeFromUTC } from '@/utils/date';

type TransactionReviewDetailsInfoProps = {
  transactionDetails: TransactionReviewTransactionDetails;
};

export default function TransactionReviewDetailsInfo({
  transactionDetails,
}: TransactionReviewDetailsInfoProps) {
  const {
    fromAccount,
    toAccount,
    expirationAt,
    displayAmount,
    deliverySpeed,
    originationMethod,
    note,
    requestedBy,
  } = transactionDetails;

  const items: SVSummaryCardItem[] = [
    {
      label: 'Form',
      text: fromAccount,
    },
    {
      label: 'To',
      text: toAccount,
    },
    {
      label: 'Expiration At',
      text: formatDateTimeFromUTC(expirationAt, true),
    },
    {
      label: 'Amount',
      customContent: <TransactionReviewAmount amount={displayAmount} />,
    },
    {
      label: 'Delivery Speed',
      text: getTransactionReviewDeliverySpeed(deliverySpeed),
    },
    {
      label: 'Origination Method',
      text: `${originationMethod ? originationMethod : 'Transaction Request'} by ${requestedBy.userName} (${requestedBy.userEmail})`,
    },
    {
      label: 'Note',
      text: note || '',
    },
  ];

  return <SVSummaryCard label="Transaction Info" items={items} />;
}
